<template>
    <v-card flat>
        <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
            <v-row class="no-gutters">
                <v-col cols="12" sm="12" md="6" lg="8">
                    <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search here ..." single-line solo
                        hide-details></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="4">
                    <ul>
                        <li>
                            <span>Master:</span>
                            <span>{{managerInvestorLiveOrders?.masterRunningOrders || 0}}</span>
                        </li>

                        <li>
                            <span>Sub-Order:</span>
                           <span>{{managerInvestorLiveOrders?.investorRunningOrders || 0}}</span>
                        </li>
                    </ul>
                </v-col>
                <!-- <v-col cols="2" sm="4" md="2" lg="1">
                    <v-div class="my-auto">
                        <v-icon @click="refresh" small color="#5F7692">mdi-refresh</v-icon>
                    </v-div>
                </v-col> -->
            </v-row>
            <v-row>
                <v-col cols="12" sm="12">
                    <v-card class="pa-3 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
                        <v-sheet class="transactionTable liveTradeTable walletTable pb-3" :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'
                            ">
                            <v-data-table :headers="headers" :items="managerInvestorLiveOrders?.finalResults" :search="search"
                                :items-per-page="6" :single-expand="true" :expanded.sync="expanded" :item-key="'manager_order'" show-expand>

                                <template v-slot:item.order="{ item }">
                                    <v-icon small color="#FF567F" class="mr-1 align-start">mdi-star-outline</v-icon>
                                    Master
                                </template>

                                <template v-slot:item.orderNo="{ item }">
                                    <span>
                                        {{ item?.ManagerOrderNo }}
                                    </span>
                                </template>

                                <template v-slot:item.Action="{ item }">
                                    <span>
                                        {{
                                            item?.Action === 1 ? "Sell" : "Buy"
                                        }}
                                    </span>
                                </template>

                                <template v-slot:item.TimeCreate="{ item }">
                                    <span>
                                        {{
                                            formatMySQLDate(item?.TimeCreate)
                                        }}
                                    </span>
                                </template>

                                <template v-slot:item.PriceSL="{ item }">
                                    <span>
                                        {{ item?.PriceSL?.toFixed(2) }} -
                                        {{ item?.PriceTP?.toFixed(2) }}
                                    </span>
                                </template>

                                <template v-slot:item.Lot="{ item }">
                                    <span class="profit-text-color">
                                        {{ item?.Lot / 10000 }}
                                    </span>
                                </template>

                                <template v-slot:item.Comment="{ item }">
                                    <span>
                                        {{ item?.Comment || "N/A" }}
                                    </span>
                                </template>

                                <template v-slot:item.Profit="{ item }">
                                    <span>
                                        {{ item?.Profit.toFixed(2) }}
                                    </span>
                                </template>

                                <template v-slot:expanded-item="{ headers, item }">
                                    <td :colspan="headers.length" class="pa-0">
                                        <v-data-table :headers="headers" :items="item?.investorsOrders"
                                            hide-default-footer hide-default-header class="childTable mx-0">
                                            <template v-slot:item.order="{ item }">
                                                <v-icon small color="#D19909"
                                                    class="mr-1 align-start">mdi-arrow-right-bottom</v-icon>
                                                Sub-Order
                                            </template>

                                            <template v-slot:item.TimeCreate="{
                                                item,
                                            }">
                                                <span>
                                                    {{
                                                        formatMySQLDate(
                                                            item?.TimeCreate
                                                        )
                                                    }}
                                                </span>
                                            </template>

                                            <template v-slot:item.PriceSL="{ item }">
                                                <span>
                                                    {{
                                                        item?.PriceSL?.toFixed(
                                                            2
                                                        )
                                                    }}
                                                    -
                                                    {{
                                                        item?.PriceTP?.toFixed(
                                                            2
                                                        )
                                                    }}
                                                </span>
                                            </template>

                                            <template v-slot:item.Action="{ item }">
                                                <span>
                                                    {{
                                                        item?.Action === 1
                                                            ? "Sell"
                                                            : "Buy"
                                                    }}
                                                </span>
                                            </template>

                                            <template v-slot:item.orderNo="{ item }">
                                                {{ item?.ManagerOrderNo }}
                                            </template>

                                            <template v-slot:item.Lot="{ item }">
                                                <span class="profit-text-color">
                                                    {{ item?.Lot / 10000 }}
                                                </span>
                                            </template>

                                            <template v-slot:item.Profit="{ item }">
                                                <span>
                                                    {{
                                                        item?.Profit?.toFixed(2)
                                                    }}
                                                </span>
                                            </template>

                                            <template v-slot:item.Comment="{ item }">
                                                <span>
                                                    {{ item?.Comment || "-" }}
                                                </span>
                                            </template>
                                        </v-data-table>
                                    </td>
                                </template>
                                
                            </v-data-table>
                        </v-sheet>
                    </v-card>
                </v-col>
            </v-row>
        </v-card>
    </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { MAM__ACTIONS } from "@/store/action-types";

export default {
    data() {
        return {
            search: "",
            expanded: [],
            singleExpand: true,
            headers: [
                {
                    text: "Order",
                    value: "order",
                },
                { text: "Type", value: "Action" },
                { text: "Order No", value: "orderNo" },
                { text: "Login", value: "Login" },
                { text: "Symbol", value: "Symbol" },
                { text: "Comment", value: "Comment" },

                { text: "Lots", value: "Lot" },
                { text: "Open Time", value: "TimeCreate" },
                { text: "SL-TP", value: "PriceSL" },
                { text: "Profit", value: "Profit" },
                { text: "Account Status", value: "data-table-expand" },
            ],
        };
    },

    computed: {
        ...mapState("mam", ["managerInvestorLiveOrders"]),
    },
    methods: {
        ...mapActions("mam", [MAM__ACTIONS.LIVEORDERSMANAGERINVESTORS]),
          formatMySQLDate(mysqlDate) {
        // Ensure the input is in the correct format
        if (!mysqlDate) return "Invalid date";

        // Replace the "T" with a space to work with the current logic
        const isoFormattedDate = mysqlDate.replace('T', ' ').split('.')[0]; // Removes milliseconds
        const [datePart, timePart] = isoFormattedDate.split(' ');
        const [year, month, day] = datePart.split('-');
        const [hour, minute] = timePart.split(':');

        // Convert 24-hour time to 12-hour time
        const hour12 = hour % 12 || 12;
        const amPm = hour >= 12 ? 'pm' : 'am';

        // Return the formatted date and time
        return `${day}.${month}.${year} - ${hour12}:${minute} ${amPm}`;
    },
    
    async refresh() {
        await this[MAM__ACTIONS.LIVEORDERSMANAGERINVESTORS](
            this.$route.query.id
        );
    },
    },
    async mounted() {
        await this[MAM__ACTIONS.LIVEORDERSMANAGERINVESTORS](
            this.$route.query.id
        );
    },
};
</script>

<style scoped>
.my-auto{
    display: flex;
    justify-content:  center;
    align-items: center;
    height: 100%;
    width: 100% ;
}
</style>
